import {_} from "vue-underscore";
import api from "../utils/api.js";
import events from "../utils/events.js";
import { trackEventByFirebase } from '../../store/utils/tracking';

export const savedProducts = {
    namespaced: true,
    state: {
        savedProducts: [],
        savedProductsCount: 0,
        savedProductsLoaded: false,
    },
    getters: {
        savedProducts(state) {
            return state.savedProducts;
        },
        savedProductsCount(state) {
            return state.savedProductsCount;
        },
        savedProductsLoaded(state) {
            return state.savedProductsLoaded;
        }
    },
    mutations: {
        scoreProduct(state, payload) {
            const { product, score, index } = payload;
            const newSavedProducts = state.savedProducts.filter(savedProduct => !(savedProduct.product_id === product.product_id));
            if(score == 1) {
                state.savedProductsCount++;
                if(typeof index !== "undefined") {
                    newSavedProducts.splice(index, 0, product);
                } else {
                    newSavedProducts.push(product);
                }
            } else {
                state.savedProductsCount--;
            }

            state.savedProducts = newSavedProducts;
        },
        setSavedProducts(state, products) {
            state.savedProducts = products;
            state.savedProductsLoaded = true;
        },
        setSavedProductsCount(state, count) {
            state.savedProductsCount = count;
        },
        resetState(state){
            state.savedProducts = [];
            state.savedProductsCount = 0;
            state.savedProductsLoaded = false;
        }
    },
    actions: {
        saveProduct(context, payload) {
            const { product, outfitId } = payload;

            return events.trackEvent(
                'save_product',
                {
                    outfitId,
                    outfitAltered: false,
                    likedProductId: product.product_id
                }
            );
        },
        unsaveProduct(context, payload) {
            const { product } = payload;

            return events.trackEvent(
                'unsave_product',
                {
                    outfitAltered: false,
                    likedProductId: product.product_id,
                    likedProductOptionValueId: product.product_option_value_id
                }
            );
        },
        scoreProduct(context, payload) {
            const { product, score, outfitId } = payload;
            return api
                .post(`${api.productsUri()}${product.product_id}/score/${score === 1 ? 'yes' : 'clear'}`, {
                    outfit_id: outfitId,
                    product_option_value_id: product.product_option_value_id,
                })
                .then(response => {
                    if(score === 1) {
                        context.dispatch('saveProduct', payload);
                    } else {
                        context.dispatch('unsaveProduct', payload);
                    }
                    context.commit('scoreProduct', payload);
                })
                .catch(response => {
                    trackEventByFirebase("save_product_error", {content_id: product.product_id});
                    context.dispatch('errors/put', response.body.message || 'An unexpected error happened.', { root: true });
                });
        },
        fetchSavedProducts(context, payload = {}) {
            const { addTotal = false } = payload;
            const uri = api.productsUri() + "saved";

            // Load filters from filter module
            const { optionValues: product_option_value_ids, maxPrice: outfit_price_max, minPrice: outfit_price_min } = context.rootGetters['filters/selectedFilters'];
            
            const selectedCategoryId = context.rootGetters['filters/selectedSavedProductsCategoryId'];
            
            const params = {
                product_option_value_ids,
                outfit_price_min,
                outfit_price_max,
                limit: 100,
                addTotal,
                product_category_id: selectedCategoryId,
            }
            
            return api
                .get(uri, {
                    params
                })
                .then(response => {
                    console.log('saved products:', response.products);
                    context.commit("setSavedProducts", response.products);
                    if(response.total) {
                        context.commit('setSavedProductsCount', response.total);
                    }
                })
                .catch(response => {
                    console.log("error fetching saved products");
                });
        },
        fetchSavedProductsGlobal: {
            root: true,
            handler(namespacedContext, payload) {
                namespacedContext.dispatch("fetchSavedProducts");
            }
        }
    }
};
